export default __webpack_public_path__ + "static/media/payroll_icon.309ffef1.svg";